import styled from "@emotion/styled";
import { css } from "@emotion/react";

export const Root = styled.header`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  align-items: flex-start;
  margin-bottom: 12px;
`;

export const TitleWrapper = styled.div`
  ${({ theme }) => css`
    ${theme.font.medium_18};
    width: 100%;
    border-bottom: 1px solid ${theme.color.gray_02};
    padding-bottom: 8px;
    color: ${theme.color.gray_09};
  `}
`;

export const UtilWrapper = styled.div`
  display: flex;
`;

export const sortSelect = css`
  width: 130px;
  margin-right: 4px;

  & > button {
    height: 36px;
  }
`;

export const searchInput = css`
  width: 324px;
  margin-right: 8px;
`;

export const addButton = css`
  height: 36px;
`;
